module.exports = __webpack_public_path__ + "static/ME381.3a4b0da1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ME381.png
// module id = 54
// module chunks = 21434532657768 117696030705815 145011745361637